import httpClient from "../axiosBase/axiosHandler";

export const getSmsCampaigns = (queries = "", queryParams = {}) => {
  return httpClient.get(`/marketing/campaign/${queries}`, {
    params: { ...queryParams },
  });
};

export const createSmsCampaigns = (data) => {
  return httpClient.post("/marketing/campaign/", data);
};

export const updateSmsCampaigns = ({ id, data }) => {
  return httpClient.patch(`/marketing/campaign/${id}/`, data);
};

export const activateSmsCampaigns = ({ id }) => {
  return httpClient.post(`/marketing/campaign/${id}/activate/`, {});
};

export const getSmsCampaignDetails = (id) => {
  return httpClient.get(`/marketing/campaign/${id}/`);
};

export const deleteSmsCampaigns = ({ id }) => {
  return httpClient.delete(`/marketing/campaign/${id}/`);
};

export const pauseSmsCampaigns = ({ id }) => {
  return httpClient.post(`/marketing/campaign/${id}/pause/`, {});
};

export const cancelSmsCampaigns = ({ id }) => {
  return httpClient.post(`/marketing/campaign/${id}/cancel/`, {});
};

export const getAudiences = (queries = "", queryParams = {}) => {
  return httpClient.get(`/marketing/audiences/${queries}`, {
    params: { ...queryParams },
  });
};

export const createAudience = (data) => {
  return httpClient.post("/marketing/audiences/", data);
};

export const getAudienceDetails = (id) => {
  return httpClient.get(`/marketing/audiences/${id}/`);
};

export const getAudienceCustomers = (id, queryParams) => {
  return httpClient.get(`/marketing/audiences/${id}/customers/`, {
    params: { ...queryParams },
  });
};

export const cloneSuggestedCampaign = ({ id }) => {
  return httpClient.post(`/marketing/campaign/${id}/clone/`, {});
};
